import type { ApiClient } from '@travel/api-client';

import type { ProviderPlanList } from 'ProviderPlanList-Types';

import type { SearchRequestBody } from '../../pages/ProviderInformationPage/resolver';

export const fetchPlanList = (http: ApiClient, req: SearchRequestBody): Promise<ProviderPlanList> =>
  http.post(`/monterosa-api/providers/plan-item-summaries`, {
    values: req,
    ignoreCommonErrorHandler: true,
  });
